export const removePathPrefix = (filename: string): string => {
  const lastSlashIndex = filename.lastIndexOf('/');

  if (lastSlashIndex === -1) {
    return filename;
  }

  return filename.substring(lastSlashIndex + 1);
};
